import { Box } from "@chakra-ui/react";
import { Footer, Header } from "components";
import Consultant from "pages/consultant";
import Consultants from "pages/consultants";
import Home from "pages/home";
import Distributor from "pages/distributor";
import Distributors from "pages/distributors";
import { BrowserRouter, Route, Routes as BrowserRoutes } from "react-router-dom";
import Orders from "pages/orders";
import Withdraws from "pages/withdraws";
import Employees from "pages/employees";
import Employee from "pages/employee";
import Reports from "pages/reports";
import Warehouse from "pages/warehouse";
import Products from "pages/products";
import Product from "pages/product";
import Fiscal from "pages/fiscal";
import Tools from "pages/tools";
import Sales from "pages/sales";
import Options from "pages/options";
import Stock from "pages/stock";

export default function Routes(){
    return(
    <>
        <Header />
        <Box ml={{ base: 0, md: "220px" }} pt="60px" overflowX="hidden">
        <BrowserRoutes>

            {/* Rotas de Consultores */}
            <Route path="/consultants" element={<Consultants />} />
            <Route path="/consultants/:id" element={<Consultant />} />

            {/* Rodas de núcleos */}
            <Route path="/distributors" element={<Distributors />} />
            <Route path="/distributors/:id" element={<Distributor />} />

            {/* Rotas de pedidos */}
            <Route path="/orders" element={<Orders />} />

            {/* Rota de Venda direta */}
            <Route path="/sales" element={<Sales />} />

            {/* Rotas do Fiscal */}
            <Route path="/fiscal" element={<Fiscal />} />

            {/* Rotas do financeiro */}
            <Route path="/withdraws" element={<Withdraws />} />

            {/* Rotas de produtos */}
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<Product />} />

            {/* Funcionários */}
            <Route path="/employees" element={<Employees />} />
            <Route path="/employees/:id" element={<Employee />} />

            {/* Relatórios */}
            <Route path="/reports" element={<Reports />} />

            {/* Ferramentas */}
            <Route path="/tools/*" element={<Tools />} />

            {/* Warehouse routes */}
            <Route path="/warehouse/*" element={<Warehouse />} />

            {/* Estoque: NF-e, movimentações e perdas */}
            <Route path="/stock/*" element={<Stock />} />

            <Route path="/options/*" element={<Options/>} />
            {/* <Route path="/options/:key" element={<Options/>} /> */}

            <Route index element={<Home />} />
        </BrowserRoutes>
        <Footer />
        </Box>
        </>
    )
}
